import { Module } from '@nu-art/ts-common';
import * as Papa from 'papaparse';
class ModuleFE_CSVParser_Class extends Module {
    fromString = (str, _config) => {
        const config = { header: true, ..._config ?? {} };
        const parsed = Papa.parse(str, config);
        if (parsed.errors.length)
            this.logError('Parsed with errors', ...parsed.errors);
        this.logDebug('Parsed metadata', parsed.meta);
        return parsed.data;
    };
    fromFile = async (file, _config) => {
        return new Promise(resolve => {
            const config = {
                header: true,
                complete: (results, file) => {
                    if (results.errors.length)
                        this.logError('Parsed with errors', ...results.errors);
                    this.logDebug('Parsed metadata', results.meta);
                    resolve(results.data);
                },
                ..._config,
            };
            Papa.parse(file, config);
        });
    };
    fromURL = async (url, _config) => {
        return new Promise((resolve, reject) => {
            // const error = tsValidate(url, tsValidateGeneralUrl());
            // if (error)
            // 	reject(error);
            const config = {
                header: true,
                complete: (results, file) => {
                    if (results.errors.length)
                        this.logError('Parsed with errors', ...results.errors);
                    this.logDebug('Parsed metadata', results.meta);
                    resolve(results.data);
                },
                ..._config,
                download: true,
            };
            Papa.parse(url, config);
        });
    };
    toString = (items, config) => {
        if (!items?.length)
            return '';
        return Papa.unparse(items, { header: true, ...(config ?? {}) });
    };
}
export const ModuleFE_CSVParser = new ModuleFE_CSVParser_Class();
//# sourceMappingURL=ModuleFE_CSVParser.js.map